module.exports = "/images/Belarus.png?6c82c40c15201f3cec6a569b0e208be7";